import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import CryptoJS from "crypto-js";
import "dayjs/locale/en"; // Importing Spanish as an example
import "dayjs/locale/nl";
import config from "../config/config";
import { GridFilterInputValue } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { t } from "i18next";
import { Rating, styled, Switch } from "@mui/material";
dayjs.extend(relativeTime);
export const getOrdinalSuffix = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
};
export const truncateText = (str, length) => {
  return str && str.length > length ? str.substring(0, length) + "..." : str;
};
export const setLocalStorage = (name, data) => {
  localStorage.setItem(`${config.NAME_KEY}:${name}`, data);
};

export const getLocalStorage = (name) => {
  const data = localStorage.getItem(`${config.NAME_KEY}:${name}`);
  if (data) {
    return data;
  }
  return undefined;
};
export const removeLocalStorage = (name) => {
  if (localStorage.getItem(`${config.NAME_KEY}:${name}`)) {
    localStorage.setItem(`${config.NAME_KEY}:${name}`, "");
  }
};
export const formatKey = (key) => {
  return key
    .replace(/_/g, " ") // Replace underscores with spaces
    .toLowerCase() // Convert the key to lowercase
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};
export const formatTime = (timestamp, locale) => {
  dayjs.locale(locale);
  const now = dayjs();
  const time = dayjs(timestamp);

  // Check if the difference is more than 24 hours
  if (now.diff(time, "hour") >= 20) {
    // Show date after 24 hours
    return time.format("DD MMM YYYY hh:mm "); // Customize the format as needed
  } else {
    // Show relative time like "1 minute ago" if within 24 hours
    return time.fromNow();
  }
};
export const formatDateShortMonth = (date, locale, format) => {
  dayjs.locale(locale);
  return dayjs(date).format(format);
};
export const truncateTextCeoMessage = (str) => {
  if (!str) return ""; // Return empty string if undefined

  // Get the current screen width
  const screenWidth = window.innerWidth;
  let length;

  // Set the truncation length based on screen width (responsive breakpoints)
  if (screenWidth > 1500) {
    length = 210; // Larger screens (e.g., desktops)
  } else if (screenWidth > 1400) {
    length = 210;
  } else if (screenWidth > 1200) {
    length = 190;
  } else if (screenWidth > 768) {
    length = 250; // Medium screens (e.g., tablets)
  } else {
    length = 40; // Smaller screens (e.g., mobile)
  }
  logger(length);
  // Truncate the text if it's longer than the calculated length
  return str.length > length ? str.substring(0, length) + "..." : str;
};
export const mergeDateTime = (selectedDate, selectedTime) => {
  if (selectedDate && selectedTime) {
    // Merge date and time
    const mergedDateTime = selectedDate
      .set("hour", selectedTime.hour())
      .set("minute", selectedTime.minute())
      .set("second", selectedTime.second());
    return mergedDateTime.format("YYYY-MM-DD HH:mm:ss");
  }
  return "Invalid DateTime";
};

const logger = (arg) => {
  if (config.SERVER !== "production") {
    // eslint-disable-next-line
    console.log(arg);
  }
  return false;
};

export default logger;

export const getSessionStorageToken = () => {
  const ciphertext = sessionStorage.getItem(`${config.NAME_KEY}:token`);
  if (ciphertext) {
    const bytes = CryptoJS.AES.decrypt(ciphertext, `${config.NAME_KEY}-token`);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  return false;
};

export const setLocalStorageToken = (token) => {
  localStorage.setItem(
    `${config.NAME_KEY}:token`,
    CryptoJS.AES.encrypt(token, `${config.NAME_KEY}-token`).toString()
  );
};

export const getLocalStorageToken = () => {
  const token = localStorage.getItem(`${config.NAME_KEY}:token`);
  if (token) {
    const bytes = CryptoJS.AES.decrypt(token, `${config.NAME_KEY}-token`);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
  return false;
};
export const removeLocalStorageToken = (navigate) => {
  if (localStorage.getItem(`${config.NAME_KEY}:token`)) {
    localStorage.setItem(`${config.NAME_KEY}:token`, null);
  }
  if (navigate) {
    navigate("/");
  }
};
export function decodeQueryData(data) {
  return JSON.parse(
    `{"${decodeURI(data)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace("?", "")}"}`
  );
}
export function routeToTitle(route) {
  return route
    .replace(/\//g, " ") // Replace slashes with spaces
    .trim() // Remove leading/trailing spaces
    .split("-") // Split words by hyphen
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join words with spaces
}
export const frappeFilterOperators = [
  {
    label: "Equals",
    value: "=",
    getApplyFilterFn: (filterItem) => (value) =>
      value?.toLowerCase() === filterItem.value?.toLowerCase(),
    InputComponent: GridFilterInputValue,
  },
  {
    label: "Not Equals",
    value: "!=",
    getApplyFilterFn: (filterItem) => (value) =>
      value?.toLowerCase() !== filterItem.value?.toLowerCase(),
    InputComponent: GridFilterInputValue,
  },
  {
    label: "Like",
    value: "like",
    getApplyFilterFn: (filterItem) => (value) =>
      value?.toLowerCase().includes(filterItem.value?.toLowerCase()),
    InputComponent: GridFilterInputValue,
  },
  {
    label: "Not Like",
    value: "not like",
    getApplyFilterFn: (filterItem) => (value) =>
      !value?.toLowerCase().includes(filterItem.value?.toLowerCase()),
    InputComponent: GridFilterInputValue,
  },
  {
    label: "In",
    value: "in",
    getApplyFilterFn: (filterItem) => (value) =>
      filterItem.value.split(",").includes(value),
    InputComponent: GridFilterInputValue,
  },
  {
    label: "Not In",
    value: "not in",
    getApplyFilterFn: (filterItem) => (value) =>
      !filterItem.value.split(",").includes(value),
    InputComponent: GridFilterInputValue,
  },
  // {
  //   label: "Is",
  //   value: "is",
  //   getApplyFilterFn: (filterItem) => (value) => filterItem.value === value,
  //   InputComponent: GridFilterInputValue,
  // },
];
export const throwErrorMsg = (err) => {
  if (err._server_messages) {
    const messages = JSON.parse(err._server_messages);
    let parsedMessage = JSON.parse(messages[0]).message;
    parsedMessage = parsedMessage.replace(/<[^>]*>/g, "");
    toast.error(
      parsedMessage ? (
        <div dangerouslySetInnerHTML={{ __html: parsedMessage }} />
      ) : (
        `${toast.error(t("text.common.Somethingwentwrong"))}`
      )
    );
  } else {
    toast.error(
      err.message ? (
        <div dangerouslySetInnerHTML={{ __html: err.message }} />
      ) : (
        `${toast.error(t("text.common.Somethingwentwrong"))}`
      )
    );
  }
};
export const startDateEndDateCheck = (start, end, t) => {
  if (start && end && dayjs(end).isBefore(dayjs(start))) {
    toast.error(t("text.common.Enddatemustbegreaterthanstartdate."));
    return true;
  }
};
export function encoder(code) {
  return window.btoa(code);
}
export function decoder(str) {
  // return window.atob(code);
  if (str === "" || str.trim() === "") {
    return false;
  }
  try {
    return window.atob(str);
  } catch (err) {
    return false;
  }
}
export const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 70,
  height: 32,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 4,
    paddingLeft: 5,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(40px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "rgba(10, 48, 104, 1)",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 23,
    height: 23,
    zIndex: 2,
  },
  "& .MuiSwitch-track": {
    backgroundColor: "rgb(178, 223, 247)",
    borderRadius: 40,
    position: "relative",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: 11,
      fontWeight: "bold",
      fontFamily: "sans-serif",
    },
    "&::before": {
      content: `"${t("text.common.On")}"`,
      left: 12,
      color: "#fff",
    },
    "&::after": {
      content: `"${t("text.common.Off")}"`,
      right: 12,
      color: "rgba(10, 48, 104, 1)",
    },
  },
}));
export const CustomSwitchWithoutName = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
    checked={props.checked}
  />
))(({ theme }) => ({
  width: 35,
  height: 21,
  padding: 0,
  display: "flex",
  "& .MuiSwitch-switchBase": {
    padding: 4,
    paddingLeft: 4,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "rgba(10, 48, 104, 1)",
        opacity: 1,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 12,
    height: 12,
    zIndex: 2,
  },
  "& .MuiSwitch-track": {
    backgroundColor: "rgb(178, 223, 247)",
    borderRadius: 40,
    position: "relative",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: 11,
      fontWeight: "bold",
      fontFamily: "sans-serif",
    },
    "&::before": {
      // content: `"${t("text.common.On")}"`,
      left: 12,
      color: "#fff",
    },
    "&::after": {
      // content: `"${t("text.common.Off")}"`,
      right: 12,
      color: "rgba(10, 48, 104, 1)",
    },
  },
}));
export const formFormaater = (type, value) => {
  if (value) {
    if (type == "CustomDate") {
      return <div>{dayjs(value).format("DD-MM-YYYY")}</div>;
    }
    // else if (type == "CustomTime") {
    //   return <div>{dayjs(value).format("HH:mm")}</div>;
    // }
    else if (type == "CustomDateTime") {
      return <div>{dayjs(value).format("DD-MM-YYYY HH:mm")}</div>;
    } else if (type == "CustomUpload") {
      return (
        <a href={value.url} target="_blank">
          {value?.name}
        </a>
      );
    } else if (type == "Rating") {
      return <Rating name="simple-controlled" defaultValue={value} />;
    } else if (type == "Checkboxes") {
      return <>{value.join(",")}</>;
    } else {
      return <>{value}</>;
    }
  } else {
    return <>-</>;
  }
};
export const widthFormFormaater = (type) => {
  if (type) {
    if (type == "CustomDate") {
      return 100;
    } else if (type == "CustomTime") {
      return 80;
    } else if (type == "CustomDateTime") {
      return 150;
    } else if (type == "CustomUpload") {
      return 150;
    } else if (type == "Rating") {
      return 150;
    } else if (type == "Checkboxes") {
      return 150;
    } else {
      return 250;
    }
  } else {
    return 100;
  }
};
export const chip = (t) => {
  return {
    "Report Recover": {
      title: t("text.hrms.ReportRecover"),
      sx: {
        color: "#004d00",
        backgroundColor: "rgb(237, 247, 237)",
        fontWeight: "bolder",
        fontSize: "0.9em",
      },
    },
    Open: {
      title: t("text.box.Pending"),
      sx: {
        color: "#ed6c02",
        backgroundColor: "transparent",
        fontWeight: "bolder",
        fontSize: "1em",
      },
    },
    Approved: {
      title: t("text.box.Approved"),
      sx: {
        color: "#004d00",
        backgroundColor: "transparent",
        fontWeight: "bolder",
        fontSize: "1em",
      },
    },
    Rejected: {
      title: t("text.box.Rejected"),
      sx: {
        color: "#d32f2f",
        backgroundColor: "transparent",
        fontWeight: "bolder",
        fontSize: "1em",
      },
    },
    Cancelled: {
      title: t("text.box.Cancelled"),
      sx: {
        color: "#d32f2f",
        backgroundColor: "transparent",
        fontWeight: "bolder",
        fontSize: "1em",
      },
    },
  };
};
